module.exports = __webpack_public_path__ + "media/theme/wall__sidebar--nintendo-b513827c.svg";